import React from "react"

export const PlayIconCircle = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 40}
      height={size * 40}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h32v32H0z" fillOpacity="0" />
        <path fill="none" d="M0 0h40v40H0z" fillOpacity="0" />
        <path fill={color} d="M15.833 13.333V27.5l13.334-7.083z" />
        <circle stroke={color} strokeWidth="3" cx="20" cy="20" r="18.5" />
      </g>
    </svg>
  )
}
